import Feedback from '../pages/feedback';
import Plans from '../pages/plans';
import Skils from '../pages/sectionsils';
import Footer from '../pages/footer';
import Friendly from '../pages/sectionprovide';
import SEO from '../Component/SEO';
export default function Pagabout() {
  return (
    <>
      <SEO
        title="Über uns - lamar-reinigung"
        description="Erfahren Sie mehr über Lamar Reinigungsservice – Ihr zuverlässiger Partner für professionelle Reinigung in Karlsruhe."
        keywords="Reinigungsunternehmen Karlsruhe, professionelle Reinigung, Reinigungsteam Deutschland"
        url="https://lamar-f7165.web.app/about"
        image="https://lamar-reinigung.de/logo.png"
      />

      <div style={{ height: '100px', width: '100%' }}></div>
      <Friendly></Friendly>
      <Skils></Skils>
      <Plans></Plans>
      <Feedback></Feedback>
      <Footer></Footer>
    </>
  );
}
